// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Articles_header__LmgDd,
.Articles_filter__zsJbF,
.Articles_tagsLoader__2\\+G7B,
.Articles_searchLoading__m-GRq,
.Articles_favLoading__BQbC6 {
  margin-bottom: 24px;
}

.Articles_header__LmgDd {
  justify-content: space-between;
  align-items: center;
}
@media (min-width: 1200px) {
  .Articles_header__LmgDd {
    display: flex;
  }
}

@media (min-width: 1200px) {
  .Articles_titleBack__d2HX4 {
    height: auto;
    margin: 0;
  }
}
@media (min-width: 1200px) {
  .Articles_titleBack__d2HX4 a {
    display: none;
  }
}
@media (min-width: 1200px) {
  .Articles_titleBack__d2HX4 h2 {
    margin-left: 0;
  }
}

.Articles_search__cx5OT {
  width: 100%;
}
@media (min-width: 1200px) {
  .Articles_search__cx5OT {
    max-width: 360px;
  }
}

.Articles_bottomGrid__r0K2P {
  display: grid;
  grid-template-columns: minmax(40px, auto);
  grid-gap: 24px;
}
@media (min-width: 640px) {
  .Articles_bottomGrid__r0K2P {
    grid-template-columns: minmax(40px, auto) minmax(20px, auto);
  }
}

.Articles_tagsLoader__2\\+G7B {
  display: flex;
  grid-gap: 8px;
}

.Articles_tagsLoaderBtn__wMNDS {
  border-radius: 47px;
  height: 32px;
  width: 60px;
}

.Articles_prevLoading__TG1EZ,
.Articles_searchLoading__m-GRq,
.Articles_favLoading__BQbC6 {
  border-radius: 12px;
}

.Articles_prevLoading__TG1EZ {
  height: 400px;
}

.Articles_searchLoading__m-GRq {
  height: 134px;
}

.Articles_favLoading__BQbC6 {
  height: 134px;
}

.Articles_nothing__1qT54 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 114%;
  margin: auto;
  width: 100%;
  position: absolute;
  top: 50%;
}
@media (min-width: 1200px) {
  .Articles_nothing__1qT54 {
    margin-top: 40px;
    position: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Articles/Articles.module.scss"],"names":[],"mappings":"AAAA;;;;;EAKE,mBAAA;AACF;;AAEA;EACE,8BAAA;EACA,mBAAA;AACF;AACE;EAJF;IAKI,aAAA;EAEF;AACF;;AAEE;EADF;IAEI,YAAA;IACA,SAAA;EAEF;AACF;AACI;EADF;IAEI,aAAA;EAEJ;AACF;AAEI;EADF;IAEI,cAAA;EACJ;AACF;;AAGA;EACE,WAAA;AAAF;AAEE;EAHF;IAII,gBAAA;EACF;AACF;;AAEA;EACE,aAAA;EACA,yCAAA;EACA,cAAA;AACF;AACE;EALF;IAMI,4DAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,aAAA;AAEF;;AACA;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AAEF;;AACA;;;EAGE,mBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;AAEF;AAAE;EAVF;IAWI,gBAAA;IACA,iBAAA;EAGF;AACF","sourcesContent":[".header,\r\n.filter,\r\n.tagsLoader,\r\n.searchLoading,\r\n.favLoading {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.header {\r\n  justify-content: space-between;\r\n  align-items: center;\r\n\r\n  @media (min-width: 1200px) {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n.titleBack {\r\n  @media (min-width: 1200px) {\r\n    height: auto;\r\n    margin: 0;\r\n  }\r\n\r\n  a {\r\n    @media (min-width: 1200px) {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  h2 {\r\n    @media (min-width: 1200px) {\r\n      margin-left: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.search {\r\n  width: 100%;\r\n\r\n  @media (min-width: 1200px) {\r\n    max-width: 360px;\r\n  }\r\n}\r\n\r\n.bottomGrid {\r\n  display: grid;\r\n  grid-template-columns: minmax(40px, auto);\r\n  grid-gap: 24px;\r\n\r\n  @media (min-width: 640px) {\r\n    grid-template-columns: minmax(40px, auto) minmax(20px, auto);\r\n  }\r\n}\r\n\r\n.tagsLoader {\r\n  display: flex;\r\n  grid-gap: 8px;\r\n}\r\n\r\n.tagsLoaderBtn {\r\n  border-radius: 47px;\r\n  height: 32px;\r\n  width: 60px;\r\n}\r\n\r\n.prevLoading,\r\n.searchLoading,\r\n.favLoading {\r\n  border-radius: 12px;\r\n}\r\n\r\n.prevLoading {\r\n  height: 400px;\r\n}\r\n\r\n.searchLoading {\r\n  height: 134px;\r\n}\r\n\r\n.favLoading {\r\n  height: 134px;\r\n}\r\n\r\n.nothing {\r\n  text-align: center;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  line-height: 114%;\r\n  margin: auto;\r\n  width: 100%;\r\n  position: absolute;\r\n  top: 50%;\r\n\r\n  @media (min-width: 1200px) {\r\n    margin-top: 40px;\r\n    position: initial;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Articles_header__LmgDd`,
	"filter": `Articles_filter__zsJbF`,
	"tagsLoader": `Articles_tagsLoader__2+G7B`,
	"searchLoading": `Articles_searchLoading__m-GRq`,
	"favLoading": `Articles_favLoading__BQbC6`,
	"titleBack": `Articles_titleBack__d2HX4`,
	"search": `Articles_search__cx5OT`,
	"bottomGrid": `Articles_bottomGrid__r0K2P`,
	"tagsLoaderBtn": `Articles_tagsLoaderBtn__wMNDS`,
	"prevLoading": `Articles_prevLoading__TG1EZ`,
	"nothing": `Articles_nothing__1qT54`
};
export default ___CSS_LOADER_EXPORT___;
